export interface ISearchBarConfig {
  // attributesToRetrieve: string[];
  // attributesToSnippet: string[];
  displayCategoryMenu?: boolean;
  from?: number;
  // hitsPerPage: number;
  // indexName: string;
  layout: ESearchResultLayout;
  routerLink: string[];
  // showStrippedBody: boolean;
  to?: number;
  totalCount?: number;
  sortOrder?: ESortOrder;
}

export enum ESearchResultLayout {
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape',
}

export enum ESortOrder {
  FEATURED = 'featured',
  ASC = 'asc',
  DESC = 'desc',
}

export interface ISearchResult {
  hits: IHit[];
  nbHits: number;
  page: number;
  nbPages: number;
  hitsPerPage: number;
  exhaustiveNbHits: boolean;
  exhaustiveTypo: boolean;
  exhaustive: {
    nbHits: boolean;
    typo: boolean;
  };
  query: string;
  params: string;
  index: string;
  renderingContent: any;
  processingTimeMS: number;
  processingTimingsMS: {
    _request: {
      roundTrip: number;
    };
  };
}

export interface ISearchResponse {
  results: ISearchResult[];
}

export interface IHit {
  id: number;
  name?: string;
  title?: string;
  uuid?: string;
  slug: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  sitemap_exclude: false,
  objectID: string;
  contents?: any[];
  format?: any;
  type?: string;
  categoryType?: ESearchCategory;
}

export enum ESearchCategory {
  CONTENT = 'Content',
  TOPICS = 'Topics',
  INDUSTRIES = 'Industries',
  BLOGS = 'Blogs',
  RECENT_SEARCHES = 'Recent Searches',
}

export interface ICombinedResults {
  label: ESearchCategory;
  hits: IHit[];
};

export type THistoryHit = (IHit & { categoryType: ESearchCategory });

export interface IHistoryResults {
  label: ESearchCategory,
  hits: THistoryHit[],
}
